import React, { useState } from "react";

function ProcessButton({ width, excelFile, imageFile, dropdownSelections, onDataUpdate, setLoading }) {
  const [errorMessage, setErrorMessage] = useState("");

  const handleProcess = async () => {
    // ✅ Check if all selections are made
    if (!excelFile || !imageFile || Object.values(dropdownSelections).includes("none")) {
      setErrorMessage("Please make all selections"); // ❌ Show error if missing input
      return;
    }

    setErrorMessage(""); // ✅ Clear any previous error
    setLoading(true); // ✅ Set loading state to true

    try {
      // ✅ Prepare form data
      const formData = new FormData();
      formData.append("excel_file", excelFile);
      formData.append("image_file", imageFile);
      formData.append("timestamp", dropdownSelections.timestamp);
      formData.append("positionID", dropdownSelections.positionID);
      formData.append("unitID", dropdownSelections.unitID);

      // ✅ Send request to API
      // const response = await fetch("https://recogtoolbox.se/api/preprocess", {
      const response = await fetch("https://recogtoolbox.se/api/preprocess", {
        method: "POST",
        body: formData,
      });

      // ✅ Parse CSV response
      if (response.ok) {
        if (!response.ok) {
          throw new Error(`Server error: ${response.status}`);
        }
        const data = await response.json();
        onDataUpdate(data.node_data, data.unitID_data); // ✅ Update variables in parent
      } else {
        setErrorMessage("Failed to process data. Try again.");
      }
    } catch (error) {
      console.error("Processing error:", error);
      setErrorMessage("Error processing request.");
    } finally {
      setLoading(false); // ✅ Reset loading state
    }
  };

  return (
    <div style={{ ...styles.container, width: `${width}px` }}>
      <button onClick={handleProcess} style={styles.button}>Process</button>
      {errorMessage && <div style={styles.errorBox}>{errorMessage}</div>} {/* ✅ Show error if needed */}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  errorBox: {
    marginTop: "10px",
    padding: "10px",
    backgroundColor: "white",
    color: "red",
    fontWeight: "bold",
    textAlign: "center",
    border: "1px solid red",
    borderRadius: "5px",
    width: "100%",
  },
};

export default ProcessButton;
